var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxTickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 0.125H1.54167C1.16594 0.125 0.805609 0.274255 0.539932 0.539932C0.274255 0.805609 0.125 1.16594 0.125 1.54167V11.4583C0.125 11.8341 0.274255 12.1944 0.539932 12.4601C0.805609 12.7257 1.16594 12.875 1.54167 12.875H11.4583C11.8341 12.875 12.1944 12.7257 12.4601 12.4601C12.7257 12.1944 12.875 11.8341 12.875 11.4583V1.54167C12.875 1.16594 12.7257 0.805609 12.4601 0.539932C12.1944 0.274255 11.8341 0.125 11.4583 0.125ZM11.4583 1.54167V11.4583H1.54167V1.54167H11.4583ZM5.08333 10.0417L2.25 7.20833L3.24875 6.2025L5.08333 8.03708L9.75125 3.36917L10.75 4.375",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTickIcon);
export default __webpack_public_path__ + "static/media/checkbox-tick-icon.0ade7793bb16ab1707f586788e369c9c.svg";
export { ForwardRef as ReactComponent };